export const Z_HEADER = 20;
export const Z_ANTD_PORTAL = 1000;
export const Z_OUTSIDE_PORTAL = 1100;
export const Z_OUTSIDE_MAGAZINE = 1200;